module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA8.377ebcf6.jpg";